<template>
<div class="box-wrap">
     <div v-if="!isLoading">
          <vue-draggable-resizable class="iconApp" :grid="grid" v-for="(element, index) in elements" :key="index.id" :x="element.x" :draggable="isDrag" @dragging="(left, top) => dragging(element.id, left, top)" @dragstop="(left, top) => dragstop(element.id, left, top)" :y="element.y" :w="element.w" :h="element.h" :resizable="false">

               <v-card flat ripple link class="mb-2 transparent" @click="openApp(element.app)">
                    <v-img :src="require('@/assets/admin/app/' + element.app.path)" width="50" height="50" :lazy-src="require('@/assets/admin/app/' + element.app.path)" aspect-ratio="1" class="transparent mx-auto">
                         <template v-slot:placeholder>
                              <v-row class="fill-height ma-0" align="center" justify="center">
                                   <v-progress-circular indeterminate color="grey lighten-5 "></v-progress-circular>
                              </v-row>
                         </template>
                    </v-img>
                    <p class="subtitle-2 mt-0 white--text text-center">{{ $t(element.app.text) }}</p>
               </v-card>{{ filteIcon }}
          </vue-draggable-resizable>
     </div>
     <div v-else class="loadings">
          <!-- <v-img  width="55%" class="mx-auto" :src="require('@/assets/loading.gif')"></v-img> -->
          <div class="loading-container">
               <div class="overly"></div>
               <div class="loading"></div>
               <div id="loading-text">{{ $t('loading') }}</div>
          </div>
     </div>

</div>
</template>

<script>
import {
     components
} from '../../plugins/compo'
export default {
     components: {
          components,
     },
     data: () => ({
          events: [' ', '', '', '', '', ''],
          NH: ((window.innerHeight - 100) / 100).toFixed(),
          prevOffsetX: 0,
          prevOffsetY: 0,
          grid: [10, 10],
          draggingId: null,
          array: [],
          isDrag: true,
          sync: false,
          elements: [{
                    id: 1,
                    x: 0,
                    y: 0,
                    text: 'Siteweb',
                    w: 100,
                    h: 84,
                    app: {
                         id: 1,
                         x: 330,
                         y: -11,
                         w: 1050,
                         h: 500,
                         currentComponent: components.siteweb,
                         zIndex: 1,
                         path: 'siteweb.png',
                         active: false,
                         items: [{
                                   id: 1,
                                   title: "acceuil",
                                   icon: "mdi-home",
                                   active: true,
                                   currentComponent: 'siteweb',
                                   children: []
                              },
                              {
                                   id: 2,
                                   title: "services",
                                   icon: "mdi-toolbox-outline",
                                   active: true,
                                   currentComponent: 'siteweb',
                                   children: []
                              },
                              {
                                   id: 3,
                                   title: "resultats",
                                   icon: "mdi-beaker-alert-outline",
                                   active: true,
                                   currentComponent: 'siteweb',
                                   children: []
                              },
                              {
                                   id: 4,
                                   title: "galeri",
                                   icon: "mdi-image",
                                   active: true,
                                   currentComponent: 'siteweb',
                                   children: []
                              },
                              {
                                   id: 5,
                                   title: "espace_patient",
                                   icon: "mdi-account",
                                   active: true,
                                   currentComponent: 'siteweb',
                                   children: []
                              },
                              {
                                   id: 6,
                                   title: "contact",
                                   icon: "mdi-account-box",
                                   active: true,
                                   currentComponent: 'siteweb',
                                   children: []
                              },
                              {
                                   id: 7,
                                   title: "news",
                                   icon: "mdi-new-box",
                                   active: true,
                                   currentComponent: 'siteweb',
                                   children: []
                              },

                         ],
                         text: 'siteweb',
                         oldPosition: {
                              w: 800,
                              h: 600,
                              x: 284,
                              y: 6
                         },
                         window: {
                              w: 0,
                              h: 0
                         },
                    }
               },
               {
                    id: 2,
                    x: 0,
                    y: 0,

                    w: 100,
                    h: 84,
                    app: {
                         id: 2,
                         x: 200,
                         y: -11,
                         w: 1200,
                         h: 600,
                         currentComponent: components.result,
                         zIndex: 7,
                         path: 'result.png',
                         active: false,
                         items: [{
                                   id: 1,
                                   title: "resultSite",
                                   icon: "mdi-test-tube",
                                   active: true,
                                   currentComponent: 'message',
                                   children: []
                              },
                              {
                                   id: 2,
                                   title: "cartFidalit",
                                   icon: "mdi-tag-heart",
                                   active: true,
                                   currentComponent: 'message',
                                   children: []
                              },
                              {
                                   id: 3,
                                   title: "demandCartFidaliti",
                                   icon: "mdi-currency-eth",
                                   active: true,
                                   currentComponent: 'message',
                                   children: []
                              },
                         ],
                         text: 'resultSite',
                         oldPosition: {
                              w: 800,
                              h: 400,
                              x: 284,
                              y: 6
                         },
                         window: {
                              w: 0,
                              h: 0
                         },
                    }
               },
               {
                    id: 3,
                    x: 0,
                    y: 0,

                    w: 100,
                    h: 84,
                    app: {
                         id: 3,
                         x: 200,
                         y: -11,
                         w: 1200,
                         h: 600,
                         currentComponent: components.question,
                         zIndex: 7,
                         path: 'question.png',
                         active: false,
                         items: [{
                              id: 1,
                              title: "question",
                              icon: "mdi-semantic-web",
                              active: true,
                              currentComponent: 'question',
                              children: []
                         }, ],
                         text: 'question',
                         oldPosition: {
                              w: 800,
                              h: 400,
                              x: 284,
                              y: 6
                         },
                         window: {
                              w: 0,
                              h: 0
                         },
                    }
               },
               {
                    id: 4,
                    x: 0,
                    y: 0,

                    w: 100,
                    h: 84,
                    app: {
                         id: 4,
                         x: 200,
                         y: -11,
                         w: 1200,
                         h: 600,
                         currentComponent: components.demande,
                         zIndex: 7,
                         path: 'demande.png',
                         active: false,
                         items: [],
                         text: 'demande',
                         oldPosition: {
                              w: 800,
                              h: 400,
                              x: 284,
                              y: 6
                         },
                         window: {
                              w: 0,
                              h: 0
                         },
                    }
               },
               {
                    id: 5,
                    x: 0,
                    y: 0,

                    w: 100,
                    h: 84,
                    app: {
                         id: 5,
                         x: 200,
                         y: -11,
                         w: 1200,
                         h: 600,
                         currentComponent: components.devis,
                         zIndex: 7,
                         path: 'devis.png',
                         active: false,
                         items: [],
                         text: 'devis',
                         oldPosition: {
                              w: 800,
                              h: 400,
                              x: 284,
                              y: 6
                         },
                         window: {
                              w: 0,
                              h: 0
                         },
                    }
               },
               {
                    id: 6,
                    x: 0,
                    y: 0,
                    w: 100,
                    h: 84,
                    app: {
                         id: 6,
                         x: 200,
                         y: -11,
                         w: 1200,
                         h: 600,
                         currentComponent: components.message,
                         zIndex: 7,
                         path: 'message.png',
                         active: false,
                         items: [{
                                   id: 1,
                                   title: "msgRecive",
                                   active: true,
                                   icon: "mdi-message-processing",
                                   currentComponent: 'message',
                                   children: []
                              },
                              {
                                   id: 2,
                                   title: "msgEnvoye",
                                   icon: "mdi-message-draw",
                                   active: true,
                                   currentComponent: 'message',
                                   children: []
                              },
                         ],
                         text: 'msg',
                         oldPosition: {
                              w: 800,
                              h: 400,
                              x: 284,
                              y: 6
                         },
                         window: {
                              w: 0,
                              h: 0
                         },
                    }
               },
               {
                    id: 7,
                    x: 0,
                    y: 0,

                    w: 100,
                    h: 84,
                    app: {
                         id: 7,
                         x: 330,
                         y: -11,
                         w: 1000,
                         h: 500,
                         currentComponent: components.Tools,
                         zIndex: 7,
                         path: 'tools1.png',
                         active: false,
                         items: [],
                         text: 'tools',
                         oldPosition: {
                              w: 800,
                              h: 400,
                              x: 284,
                              y: 6
                         },
                         window: {
                              w: 0,
                              h: 0
                         },
                    }
               },
          ]
     }),
     methods: {
          dispatch() {
               this.$store.dispatch('getMessage')
               this.$store.dispatch('getDemandes')
               this.$store.dispatch('getQuastion')
          },
          dragging(id, left, top) {
               this.draggingId = id
               if (!this.sync) return;
               const offsetX = left - this.draggingElemant.x
               const offsetY = top - this.draggingElemant.y
               const deltaX = this.deltaX(offsetX)
               const deltaY = this.deltaY(offsetY)
               this.elements.map(e => {
                    if (e.id !== id) {
                         e.x += deltaX
                         e.y += deltaY
                    }
                    return e
               })
          },
          dragstop(id, left, top) {
               this.elements.map(e => {
                    if (e.id === id) {
                         e.x = left
                         e.y = top
                    }
                    return e
               })
               this.draggingId = null
               this.prevOffsetX = 0
               this.prevOffsetY = 0
          },
          deltaX(offsetX) {
               const ret = offsetX - this.prevOffsetX
               this.prevOffsetX = offsetX
               return ret
          },
          deltaY(offsetY) {
               const ret = offsetY - this.prevOffsetY
               this.prevOffsetY = offsetY
               return ret
          },
          openApp(e) {
               setTimeout(() => {
                    this.siteweb.filter(e => {
                         this.array.push({
                              idPage: e.idPage,
                              idSection: e.idSection

                         })
                    })
                    this.elements.filter(e => {
                         if (e.id == 1) {
                              e.app.items.filter(r => {
                                   let array2 = this.uniqueArray(this.array)
                                   array2.filter(t => {
                                        if (r.id == t.idPage) {
                                             r.children.push({
                                                  id: t.idSection,
                                             }, )
                                        }
                                   })

                              })

                         }

                    })
               }, 2000);
               Fire.$emit('openApp', e, false);
          },
          uniqueArray(array) {
               return array.filter((thing, index) => {
                    const _thing = JSON.stringify(thing);
                    return index === array.findIndex(obj => {
                         return JSON.stringify(obj) === _thing;
                    });
               });
          }
     },
     computed: {
          isLoading() {

               return this.$store.state.isLoadings
          },
          siteweb() {
               return this.$store.state.website
          },
          filteIcon() {
               var xx = 5;
               var yy = 0;
               var rtl = 1;

               if (this.$vuetify.rtl) {
                    rtl = (((window.innerWidth - 100) / 100)).toFixed();
                    xx = (rtl - 30)
               }
               this.elements.map((r, i) => {
                    var t = i + 2;
                    r.x = xx;
                    r.y = yy;
                    yy += 120;
                    if (t % this.NH == 0 && i > 0) {
                         yy = 0
                         if (this.$vuetify.rtl) {
                              xx -= 100;
                         } else {
                              xx += 100;
                         }
                    }

               });
               return ''
          },
          draggingElement() {
               if (!this.draggingId) return;
               return this.elements.find(e => e.id === this.draggingId);
          },

     },
     created() {
          this.$store.dispatch('getMessage')
          this.$store.dispatch('getDemandes')
          this.$store.dispatch('getQuastion')

     },
     mounted() {
          this.events.forEach(function (event) {
               window.addEventListener(event, this.dispatch)

          }, this)
     },
}
</script>

<style lang="scss">
.iconApp {
     border: none !important;
     padding-top: 1px;
}

.loadings {
     position: absolute;
     top: 0;
     bottom: 0;
     z-index: 89899898989;
     left: 0;
     right: 0;
     height: 100%;
     width: 100%;
     #link {
          color: #E45635;
          display: block;
          font: 12px "Helvetica Neue", Helvetica, Arial, sans-serif;
          text-align: center;
          text-decoration: none;
     }

     #link:hover {
          color: #CCCCCC
     }

     #link,
     #link:hover {
          -webkit-transition: color 0.5s ease-out;
          -moz-transition: color 0.5s ease-out;
          -ms-transition: color 0.5s ease-out;
          -o-transition: color 0.5s ease-out;
          transition: color 0.5s ease-out;
     }

     /** BEGIN CSS **/
     body {
          background: #333333;
     }

     @keyframes rotate-loading {
          0% {
               transform: rotate(0deg);
               -ms-transform: rotate(0deg);
               -webkit-transform: rotate(0deg);
               -o-transform: rotate(0deg);
               -moz-transform: rotate(0deg);
          }

          100% {
               transform: rotate(360deg);
               -ms-transform: rotate(360deg);
               -webkit-transform: rotate(360deg);
               -o-transform: rotate(360deg);
               -moz-transform: rotate(360deg);
          }
     }

     @-moz-keyframes rotate-loading {
          0% {
               transform: rotate(0deg);
               -ms-transform: rotate(0deg);
               -webkit-transform: rotate(0deg);
               -o-transform: rotate(0deg);
               -moz-transform: rotate(0deg);
          }

          100% {
               transform: rotate(360deg);
               -ms-transform: rotate(360deg);
               -webkit-transform: rotate(360deg);
               -o-transform: rotate(360deg);
               -moz-transform: rotate(360deg);
          }
     }

     @-webkit-keyframes rotate-loading {
          0% {
               transform: rotate(0deg);
               -ms-transform: rotate(0deg);
               -webkit-transform: rotate(0deg);
               -o-transform: rotate(0deg);
               -moz-transform: rotate(0deg);
          }

          100% {
               transform: rotate(360deg);
               -ms-transform: rotate(360deg);
               -webkit-transform: rotate(360deg);
               -o-transform: rotate(360deg);
               -moz-transform: rotate(360deg);
          }
     }

     @-o-keyframes rotate-loading {
          0% {
               transform: rotate(0deg);
               -ms-transform: rotate(0deg);
               -webkit-transform: rotate(0deg);
               -o-transform: rotate(0deg);
               -moz-transform: rotate(0deg);
          }

          100% {
               transform: rotate(360deg);
               -ms-transform: rotate(360deg);
               -webkit-transform: rotate(360deg);
               -o-transform: rotate(360deg);
               -moz-transform: rotate(360deg);
          }
     }

     @keyframes rotate-loading {
          0% {
               transform: rotate(0deg);
               -ms-transform: rotate(0deg);
               -webkit-transform: rotate(0deg);
               -o-transform: rotate(0deg);
               -moz-transform: rotate(0deg);
          }

          100% {
               transform: rotate(360deg);
               -ms-transform: rotate(360deg);
               -webkit-transform: rotate(360deg);
               -o-transform: rotate(360deg);
               -moz-transform: rotate(360deg);
          }
     }

     @-moz-keyframes rotate-loading {
          0% {
               transform: rotate(0deg);
               -ms-transform: rotate(0deg);
               -webkit-transform: rotate(0deg);
               -o-transform: rotate(0deg);
               -moz-transform: rotate(0deg);
          }

          100% {
               transform: rotate(360deg);
               -ms-transform: rotate(360deg);
               -webkit-transform: rotate(360deg);
               -o-transform: rotate(360deg);
               -moz-transform: rotate(360deg);
          }
     }

     @-webkit-keyframes rotate-loading {
          0% {
               transform: rotate(0deg);
               -ms-transform: rotate(0deg);
               -webkit-transform: rotate(0deg);
               -o-transform: rotate(0deg);
               -moz-transform: rotate(0deg);
          }

          100% {
               transform: rotate(360deg);
               -ms-transform: rotate(360deg);
               -webkit-transform: rotate(360deg);
               -o-transform: rotate(360deg);
               -moz-transform: rotate(360deg);
          }
     }

     @-o-keyframes rotate-loading {
          0% {
               transform: rotate(0deg);
               -ms-transform: rotate(0deg);
               -webkit-transform: rotate(0deg);
               -o-transform: rotate(0deg);
               -moz-transform: rotate(0deg);
          }

          100% {
               transform: rotate(360deg);
               -ms-transform: rotate(360deg);
               -webkit-transform: rotate(360deg);
               -o-transform: rotate(360deg);
               -moz-transform: rotate(360deg);
          }
     }

     @keyframes loading-text-opacity {
          0% {
               opacity: 0
          }

          20% {
               opacity: 0
          }

          50% {
               opacity: 1
          }

          100% {
               opacity: 0
          }
     }

     @-moz-keyframes loading-text-opacity {
          0% {
               opacity: 0
          }

          20% {
               opacity: 0
          }

          50% {
               opacity: 1
          }

          100% {
               opacity: 0
          }
     }

     @-webkit-keyframes loading-text-opacity {
          0% {
               opacity: 0
          }

          20% {
               opacity: 0
          }

          50% {
               opacity: 1
          }

          100% {
               opacity: 0
          }
     }

     @-o-keyframes loading-text-opacity {
          0% {
               opacity: 0
          }

          20% {
               opacity: 0
          }

          50% {
               opacity: 1
          }

          100% {
               opacity: 0
          }
     }

     .overly {
          background: #0c0b0b4b;
          position: absolute;
          top: -10000px;
          right: -10000px;
          bottom: -10000px;
          left: -10000px;
     }

     .loading-container,
     .loading {

          height: 600px;
          position: relative;
          width: 600px;
          border-radius: 100%;
     }

     .loading-container {
          position: relative;
          margin: 40px auto
     }

     .loading {
          border: 2px solid transparent;
          border-color: transparent #fff transparent #FFF;
          -moz-animation: rotate-loading 1.5s linear 0s infinite normal;
          -moz-transform-origin: 50% 50%;
          -o-animation: rotate-loading 1.5s linear 0s infinite normal;
          -o-transform-origin: 50% 50%;
          -webkit-animation: rotate-loading 1.5s linear 0s infinite normal;
          -webkit-transform-origin: 50% 50%;
          animation: rotate-loading 1.5s linear 0s infinite normal;
          transform-origin: 50% 50%;
     }

     .loading-container:hover .loading {
          border-color: transparent #E45635 transparent #E45635;
     }

     .loading-container:hover .loading,
     .loading-container .loading {
          -webkit-transition: all 0.5s ease-in-out;
          -moz-transition: all 0.5s ease-in-out;
          -ms-transition: all 0.5s ease-in-out;
          -o-transition: all 0.5s ease-in-out;
          transition: all 0.5s ease-in-out;
     }

     #loading-text {
          -webkit-animation: loading-text-opacity 2s linear 0s infinite normal;
          animation: loading-text-opacity 2s linear 0s infinite normal;
          color: #ffffff;
          font-family: "Helvetica Neue, "Helvetica ", ""arial";
          font-size: 70px;
          font-weight: bold;
          margin-top: 199px;
          /* margin: auto; */
          opacity: 0;
          position: absolute;
          text-align: center;
          text-transform: uppercase;
          top: 0;
          width: 600px;
     }
}
</style>
